<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-dark position-fixed w-100" id="navbar">
            <div class="container-sm">
                <router-link class="navbar-brand" to="/">
                    <svg id='nav-logo' data-name="Laag 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 812.72 113.37"><path d="M545.11,381.93a31.52,31.52,0,0,1,23.25-9.64h91.06V485.66h-26V398.18h-65a6.9,6.9,0,0,0-6.84,6.84v80.64h-26V405.18A31.49,31.49,0,0,1,545.11,381.93Z" transform="translate(-535.47 -372.29)"/><path d="M790,398.18H700.86V416H790v26H700.86V453.7a6.15,6.15,0,0,0,2,4.43,6.63,6.63,0,0,0,4.9,1.71H790v25.82H707.78q-13.21,0-23.25-10A32.15,32.15,0,0,1,675,452v-79.7H790Z" transform="translate(-535.47 -372.29)"/><path d="M805.52,406a32.08,32.08,0,0,1,9.57-23.64q9.95-10,23.24-10h91.76V452a32.12,32.12,0,0,1-9.57,23.64q-9.94,10-23.25,10H838.33q-13.29,0-23.24-10A32.12,32.12,0,0,1,805.52,452Zm25.89,47.74a6.35,6.35,0,0,0,2,4.43,6.94,6.94,0,0,0,4.89,1.71h7.94v-.08h43.07v.08h7.93a7,7,0,0,0,4.9-1.71,6.34,6.34,0,0,0,2-4.43V398.18H846.27v-.08h-7.94a6.94,6.94,0,0,0-4.89,1.71,6.35,6.35,0,0,0-2,4.43Z" transform="translate(-535.47 -372.29)"/><path d="M1067.1,372.29v25.89h-47v87.48H994.24V398.18h-48.6V372.29Z" transform="translate(-535.47 -372.29)"/><path d="M1197.65,398.18h-89.11V416h89.11v26h-89.11V453.7a6.15,6.15,0,0,0,2,4.43,6.63,6.63,0,0,0,4.9,1.71h82.19v25.82h-82.19q-13.21,0-23.25-10a32.11,32.11,0,0,1-9.56-23.64v-79.7h115Z" transform="translate(-535.47 -372.29)"/><path d="M1348.19,372.29,1303.4,429l44.79,56.69h-32l-35.54-45-35.53,45h-32L1258,429l-44.79-56.68h32l35.53,44.94,35.54-44.94Z" transform="translate(-535.47 -372.29)"/></svg>
                </router-link>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <!-- <span class="navbar-toggler-icon"></span> -->
                    <font-awesome-icon :icon="['fasr', 'grip-lines']" />
                </button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav me-auto mb-lg-0">
                        <li class="nav-item">
                            <router-link class="nav-link" to="/">Home</router-link>
                        </li>
                        <!-- <li class="nav-item">
                            <router-link class="nav-link" to="/functies">Functies</router-link>
                        </li> -->
                    </ul>
                    <ul class="navbar-nav ms-auto mb-lg-0">
                        <!-- <li class="nav-item">
                            <router-link class="nav-link" to="/ombouwen">Ombouwen</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/contact">Contact</router-link>
                        </li> -->
                        <li class="nav-item">
                            <router-link class="nav-link" to="#">Nieuwe site binnenkort beschikbaar.</router-link>
                        </li> 
                    </ul>
                </div>
            </div>
        </nav>
        <div id="nav-page-padding"></div>
    </div>
</template>

<style scoped>
    #navbar {
        z-index: 1000;
        /* background-color: #fff; */
        /* mix-blend-mode: difference; */
        /* padding: 16px 0; */
        border-bottom: 1px solid var(--off-black);
        background: rgba(0, 0, 0, 0.84);
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
    }
    #navbar .navbar-brand {
        fill: #fff !important;
        margin-top: 0;
        pointer-events: none;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 5px;
    }

    #navbar .navbar-toggler {
        border: none;
        color: rgba(255, 255, 255, 0.9);
        transition: transform 0.3s ease;
        transform: rotate(0deg);
    }

    #navbar .navbar-toggler.collapsed {
        transform: rotate(0deg);
    }

    #navbar .navbar-toggler:not(.collapsed) {
        transform: rotate(90deg);
    }

    #navbar .navbar-toggler:focus {
        box-shadow: none;
    }

    #nav-logo {
        height: 12px;
        fill: #fff;
        margin: 0;
    }
    #nav-page-padding {
        height: 49px;
    }
    .nav-link{
        font-weight: 500;
        font-size: 0.85rem;
        color: rgba(255, 255, 255, 0.9) !important;
    }
    @media screen and (max-width: 768px) {
        #navbar .navbar-brand {
            position: static;
            transform: none;
            pointer-events: auto;
        }
        .nav-item{
            padding: 4px 10px;
        }
        .nav-link{
            font-size: 1.1rem;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.7) !important;
        }
    }
    
    
</style>